import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { DevicesService, CachedDataService, ScreenService, StateService, AppService } from '@services';


/*Models */
import { Device } from '@models/device';

import { Pager } from '../../shared/pager';


/*Models */
import { Track } from '@models/track';

/*Plugins */
import { IMyDpOptions } from 'mydatepicker';
import { IMyDrpOptions, IMyDateRangeModel } from 'mydaterangepicker';
import { OwlCarousel } from 'ngx-owl-carousel';
import * as moment from 'moment';

/*Config */
import { CONFIG } from '../../config';


@Component({
  selector: 'app-tracks',
  templateUrl: './tracks.component.html'
})

export class TracksComponent implements OnInit, OnDestroy {
  @ViewChild('tracksSlider') tracksSlider: OwlCarousel;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public tracks: Track[];
  public selectedTrack: Track;
  private currentDevice: Device;
  public selectedDate;
  public pager: Pager;
  public isLoadData = true;
  private currentDate: any;
  trackFindAddressCurrentIndex;
  fromDate: any;
  toDate: any;
  statisticData;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy',
    monthSelector: true,
    editableDateField: false,
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    yearSelector: false,
    disableSince: { year: 0, month: 0, day: 0 },
    dayLabels: CONFIG.dayLabels,
    monthLabels: CONFIG.monthLabels
  };

  constructor(
    private devicesService: DevicesService,
    private cachedDataService: CachedDataService,
    private stateService: StateService,
    public screenService: ScreenService,
    private appService: AppService
  ) {
    this.screenService.isDataLoadingSubject.next(true);
    this.pager = new Pager(8);

  }

  ngOnInit() {
    this.stateService.autoUpdatePositionSubject.next(false);
    this.screenService.isStateHidden = true;

    this.screenService.isDataLoadingObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(value => {
        this.isLoadData = value;
      });
    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
        this.init();
        this.getStatistic();
      });

  }
  getStatistic() {
    this.devicesService.getStatsTrack(this.currentDevice.id, 1553126400, 1556011483)
      .subscribe(response => {
        console.log(response);
      }, errors => {
        console.log(errors);
      });
  }

  init() {
    this.screenService.removeMarker();
    this.initDate();
    this.updateTracks();
  }


  updateTracks() {
    const userDateTimeOffset = this.appService.userTimezoneOffset();
    const date = this.selectedDate.date;
    const fromMoment = moment.utc({ year: date.year, month: date.month - 1, date: date.day });
    const toMoment = moment.utc({ year: date.year, month: date.month - 1, date: date.day });
    const from = fromMoment.startOf('day').subtract(userDateTimeOffset, 'h').unix();
    const to = toMoment.endOf('day').subtract(userDateTimeOffset, 'h').unix();


    this.devicesService.getTracks(this.currentDevice.id, from, to).subscribe(result => {
      if(result && result.length){
        result.map(track=>{
          track.startLatitude = parseFloat(track.startLatitude.toString().replace(",","."))
          track.finishLatitude = parseFloat(track.finishLatitude.toString().replace(",","."))
          track.startLongitude = parseFloat(track.startLongitude.toString().replace(",","."))
          track.finishLongitude = parseFloat(track.finishLongitude.toString().replace(",","."))

          track.distance = parseFloat(track.distance.toString().replace(",","."))
          track.speed = parseFloat(track.speed.toString().replace(",","."))
          track.items.map(item=>{
            item.latitude = parseFloat(item.latitude.toString().replace(",","."))
            item.longitude = parseFloat(item.longitude.toString().replace(",","."))
          })
        })
      }
      this.tracks = result;
      this.pager.pages = null;

      if (this.tracks.length) {
        this.pager.toFirstSlide(this.tracksSlider);
        this.pager.setData(JSON.parse(JSON.stringify(this.tracks)));
        this.screenService.cleanTracksData();
        const that = this;
        setTimeout(() => {

          that.screenService.showAllTracks(that.tracks);
        }, 300);

        this.trackFindAddress();
      } else {
        this.screenService.cleanTracksData();
      }
      this.screenService.isDataLoadingSubject.next(false);




    });
  }



  trackFindAddress() {
    this.trackFindAddressCurrentIndex = -1;
    this.trackFindAddressNext();
  }

  trackFindAddressNext() {
    if (!this.tracks) {
      return;
    }
    const track = this.tracks[++this.trackFindAddressCurrentIndex];
    if (track) {
      this.trackFindAddressProcess(track);
    }
  }


  public trackFindAddressProcess(track) {
    this.screenService.trackGetAddress(track.startLatitude, track.startLongitude, (address) => {
      track.startAddress = address;
      this.screenService.trackGetAddress(track.finishLatitude, track.finishLongitude, (address) => {
        track.finishAddress = address;
        if (track.startAddress && track.finishAddress) {
          this.trackFindAddressNext();
          this.pager.updateDataTrack(track);
        } else {
          const that = this;
          setTimeout(function () {
            that.trackFindAddressCurrentIndex--;
            that.trackFindAddressNext();
          }, 3000);
        }
      });
    });
  }




  onDateChanged(dateChangedEvent) {
    this.screenService.isDataLoadingSubject.next(true);
    this.selectedDate = dateChangedEvent;
    this.updateTracks();
  }

  selectTrack(track) {
    this.selectedTrack = track;
    this.screenService.showSingleTrack(track);
  }

  showAllTracks() {
    this.selectedTrack = null;
    if (this.tracks && this.tracks.length) {
      this.screenService.showAllTracks(this.tracks);
    }
  }
  private initDate() {
    const currentMoment = moment();
    this.currentDate = {
      year: currentMoment.year(),
      month: currentMoment.month() + 1,
      day: currentMoment.date(),
    };

    this.selectedDate = {
      date: this.currentDate
    };
    const today = new Date(currentMoment.year(), currentMoment.month(), currentMoment.date());
    const tomorrow = new Date(new Date().setHours(0, 0, 0, 0));

    tomorrow.setDate(today.getDate() + 1);

    const copy = this.getCopyOfOptions();
    copy.disableSince = {
      year: tomorrow.getFullYear(),
      month: tomorrow.getMonth() + 1,
      day: tomorrow.getDate(),
    };
    this.myDatePickerOptions = copy;
  }


  /*Statistic */
  getCopyOfOptions() {
    return JSON.parse(JSON.stringify(this.myDatePickerOptions));
  }

  ngOnDestroy() {
    this.screenService.isDataLoadingSubject.next(true);
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.stateService.autoUpdatePositionSubject.next(true);
    this.screenService.cleanTracksData();
  }
}




// WEBPACK FOOTER //
// ./src/app/view/tracks/tracks.component.ts